// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--X0XXV"};